import {ReconciliationReport} from '../types';

// FNP-535: a reconciliation run "has discrepancies" when ANY of the three set-compare
// counts is non-zero — our EMITTED events the channel didn't see (oursButNotTheirs),
// the channel's events we never emitted (theirsButNotOurs), or quantity mismatches.
// A human must see this without reading CloudWatch: a clean run (all zero) means our
// billing matched the channel's authoritative list for that (channel, day).
export const hasDiscrepancies = (
    record: Pick<ReconciliationReport, 'oursButNotTheirsCount' | 'theirsButNotOursCount' | 'quantityMismatchCount'>,
): boolean =>
    (record.oursButNotTheirsCount ?? 0) > 0 ||
    (record.theirsButNotOursCount ?? 0) > 0 ||
    (record.quantityMismatchCount ?? 0) > 0;

// Total discrepancy count across the three categories — for a compact summary.
export const totalDiscrepancies = (
    record: Pick<ReconciliationReport, 'oursButNotTheirsCount' | 'theirsButNotOursCount' | 'quantityMismatchCount'>,
): number =>
    (record.oursButNotTheirsCount ?? 0) +
    (record.theirsButNotOursCount ?? 0) +
    (record.quantityMismatchCount ?? 0);
